import { render, staticRenderFns } from "./OnholdRoutePage.vue?vue&type=template&id=44e3b315&"
import script from "./OnholdRoutePage.vue?vue&type=script&lang=js&"
export * from "./OnholdRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports